import { render, staticRenderFns } from "./VehiclePrice.vue?vue&type=template&id=15fb5840&scoped=true"
import script from "./VehiclePrice.vue?vue&type=script&lang=js"
export * from "./VehiclePrice.vue?vue&type=script&lang=js"
import style0 from "./VehiclePrice.vue?vue&type=style&index=0&id=15fb5840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb5840",
  null
  
)

export default component.exports